define(['handlebars', 'i18next'], function(handlebars, i18next) {

	return function(key, day) {

		var result = i18next.t(key+day);
		return new handlebars.SafeString(result);
	}

});
